const enum Coordinate {
    Y = "y",
    X = "x"
}
export default Coordinate;